import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DadosQuizEstiloDeVidaService {

  orientacao(): Observable<any> {
    return of([
      { titulo: 'NUNCA', texto: 'Absolutamente não faz parte do seu estilo de vida.', cor: '#F27895', corClaro: '#F9EEEE' },//VERMELHO
      { titulo: 'RARAMENTE', texto: 'Às vezes corresponde ao seu comportamento.', cor: '#9B966C', corClaro: '#FAF6D7' },//AMARELO
      { titulo: 'QUASE SEMPRE', texto: 'Quase sempre verdadeiro no seu comportamento.', cor: '#63c3d1', corClaro: '#d4f2f7' },//AZUL
      { titulo: 'SEMPRE', texto: 'A afirmação é sempre verdadeira no seu dia-a-dia, faz parte do seu estilo de vida.', cor: '#8fd694', corClaro: '#d6f4d9' },//VERDE
    ])
  }

  grafico(valorAlimentacao: number, valorAtividadeFisica: number, valorComportamentoPositivo: number, valorRelacionamentos: number, valorControleEstresse: number): Observable<any> {
    return of([
      { nome: 'ALIMENTAÇÃO', valor: valorAlimentacao, cor: '#F9AB41', corClaro: '#fee3c5' },
      { nome: 'ATIVIDADE FÍSICA', valor: valorAtividadeFisica, cor: '#8fd694', corClaro: '#d6f4d9' },
      { nome: 'COMPORTAMENTO POSITIVO', valor: valorComportamentoPositivo, cor: '#63c3d1', corClaro: '#d4f2f7' },
      { nome: 'RELACIONAMENTOS', valor: valorRelacionamentos, cor: '#e47bd9', corClaro: '#f9d9f4' },
      { nome: 'CONTROLE DO ESTRESSE', valor: valorControleEstresse, cor: '#f4dc6b', corClaro: '#fbf4c5' }
    ])
  }

  mensagemResultado(): Observable<any> {
    return of([
      {
        corTexto: "#754848",
        corFundo: "#F9EEEE",
        mensagem: `O seu estilo de vida interfere negativamente sua saúde, então é importante mudar alguns hábitos.
        Estas mudanças levam tempo, então comece aos poucos e seja paciente consigo! Nunca é tarde para começar! Um caminho possível é buscar apoio de amigos,
        familiares ou até mesmo ajuda profissional. A chave para conseguir bons resultados é a consistência, mantenha-se firme em seus objetivos.
        Um pouquinho todos os dias e logo você estará construindo um estilo de vida melhor!<br><br>O que você ganha melhorando os seus hábitos?<br>
        Muitas coisas, mas veja alguns exemplos:
        <ul>
        <li>* mais sensação de bem-estar e disposição para o dia a dia;</li>
        <li>* prevenção de doenças;</li>
        <li>* fortalecimento da autoestima e melhora nos relacionamentos;</li>
        <li>* aumento da longevidade;</li>
        </ul>`,
        img: '../../../../assets/app-assets/images/icones-geia/quiz-estilo-de-vida/emoji-resultado-ruim.svg'
      },
      {
        corTexto: "#9B966C",
        corFundo: "#FAF6D7",
        mensagem: "Você está no caminho certo para ter um estilo de vida saudável! Que tal aproveitar esse momento para rever alguns hábitos. Comece pelo que está mais crítico ou lhe incomodando. Para isso, analise bem os seus resultados aqui e siga mudando aos poucos. A chave para conseguir bons resultados é a consistência, mantenha-se firme em seus objetivos. Estudos científicos apontam que bons hábitos de saúde são capazes de prevenir doenças, fortalecer nossa qualidade de vida e aumentar a nossa longevidade. Esses bons hábitos são protetores da nossa saúde de uma forma geral e podem até mesmo minimizar os efeitos dos nossos fatores genéticos!",
        img: '../../../../assets/app-assets/images/icones-geia/quiz-estilo-de-vida/emoji-resultado-intermediario.svg'
      },
      {
        corTexto: "#91D270",
        corFundo: "#E9FFEE",
        mensagem: "Parabéns! Você tem um estilo de vida saudável! Forteleça e mantenha aquilo que você já está fazendo bem e aproveite esse momento rever alguns hábitos que podem ser melhorados. Estudos científicos apontam que bons hábitos de saúde são capazes de prevenir doenças, fortalecer nossa qualidade de vida e aumentar a nossa longevidade. Então se mantenha nesse caminho, agregue cada vez mais bons hábitos e incentive outras pessoas!",
        img: '../../../../assets/app-assets/images/icones-geia/quiz-estilo-de-vida/emoji-resultado-bom.svg'
      }
    ])
  }

}
